module.exports = "<div class=\"react-app\" id=\"style-guide-react\"></div>";